import React from 'react';
import '../template-file-css/document-file-template.css';


export const RNFI_PlanSignaturePage = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RNFI_PlanSignaturePage' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <h3> <b> Ravens Nest Foundation, INC </b> </h3> </center>
                </p>
                <p className='w-750'> <center> <h4> <b> Treatment Plan Signature Page </b> </h4> </center>
                </p>
                <p className='w-750'> <center> <h6> <b> Treatment Review </b> </h6> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTreatment' name='cbTreatment' className='add-only' value='Initial Treatment Plan' /> Initial Treatment Plan <br />
                            <input type='checkbox' id='cbReview' name='cbReview' className='add-only' value='30 Day Treatment Plan Review' /> 30 Day Treatment Plan Review <br />
                            <input type='checkbox' id='cbDayTreatment' name='cbDayTreatment' className='add-only' value='60 Day Treatment Plan' /> 60 Day Treatment Plan <br />
                            <input type='checkbox' id='cbTreatmentPlan' name='cbTreatmentPlan' className='add-only' value='90 Day Treatment Plan/Review' /> 90 Day Treatment Plan/Review
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    I (Consumer) &nbsp;
                    <input type='text' id='txtConsumer' name='txtConsumer' className='add-only w-200 custom-add-only' /> &nbsp;
                    have been educated about my diagnosis, its cause, the nature, duration and plan of treatment. By signing below, indicates that I am in agreement with my treatment services.
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOfferedAcopy' name='cbOfferedAcopy' className='add-only' value='As the Consumer' /> As the Consumer, I have been given and/or offered a copy of my Treatment Plan.
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-300'> &nbsp; </td>
                        <td className='signature w-250'> &nbsp; </td>
                        <td className='signature w-200'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'> Consumer/Guardian Printed Name </td>
                        <td className='small w-250'> Consumer/Guardian Signature </td>
                        <td className='small w-200'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-300'> &nbsp; </td>
                        <td className='signature w-250'> &nbsp; </td>
                        <td className='signature w-200'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'> Treatment Consultant's Printed Name </td>
                        <td className='small w-250'> Treatment Consultant's Signature </td>
                        <td className='small w-200'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-300'> &nbsp; </td>
                        <td className='signature w-250'> &nbsp; </td>
                        <td className='signature w-200'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'> Clinical Supervisor's Printed Name </td>
                        <td className='small w-250'> Clinical Supervisor's Signature </td>
                        <td className='small w-200'> Date </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}











